import WanderCRS from './WanderCRS'
import { Point } from './BasicTypes'

/**
 * Legacy CRS is a Coordinate Reference System mapping
 */
export default class LegacyCRS {
  private readonly wanderCRS: WanderCRS
  private readonly xScale: number
  private readonly yScale: number
  private readonly v0: Point

  get legacyToWanderScale (): number {
    return this.xScale
  }

  constructor (wanderCRS: WanderCRS) {
    this.wanderCRS = wanderCRS
    // (
    //   legacy boundary box width in wander CRS /
    //   legacy boundary width in legacy CRS
    // ), in other words, it's scale of X
    this.xScale = 1023.9999999999941 / 40075016.685578264
    // the same, but for y direction
    this.yScale = 1020.6455505181614 / 39943737.76081713
    // the original vector from wander origin point to legacy origin, in
    // wander CRS
    this.v0 = {
      x: 2.8990143619012088e-12,
      y: 1.6772247409193142
    }
  }

  /**
   * Convert given legacy CRS point to wander CRS point
   * @param point point in legacy CRS
   */
  legacyToWander (point: Point): Point {
    // we calculate the numbers here with level 10, so let's adjust the scale
    // if the wander CRS is using a level different than 10
    const levelDiff = this.wanderCRS.level - 10
    const scale = Math.pow(2, levelDiff)
    return {
      x: (this.v0.x + point.x * this.xScale) * scale,
      y: (this.v0.y + point.y * this.yScale) * scale
    }
  }

  /**
   * Convert given wander CRS point to legacy CRS point
   * @param point point in wander CRS
   */
  wanderToLegacy (point: Point): Point {
    // we calculate the numbers here with level 10, so let's adjust the scale
    // if the wander CRS is using a level different than 10
    const levelDiff = this.wanderCRS.level - 10
    const scale = Math.pow(2, levelDiff)
    return {
      x: (point.x / scale - this.v0.x) / this.xScale,
      y: (point.y / scale - this.v0.y) / this.yScale
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/models/LegacyCRS.ts